import * as amplitude from '@amplitude/analytics-browser';

interface Fee {
    id: string;
    label: string;
    pricing: Record<string, number>;
}

interface FormattedTrip {
    arriveName?: string;
    carrierCode?: string;
    carrierFees?: Fee[];
    departName?: string;
    isRouted?: boolean;
    taxes?: string | boolean;
    tripId?: string;
}

function priceBreakdownButtonClicked({
    returnTripId,
    totalPriceInUSD,
    trips,
}: {
    returnTripId?: string;
    totalPriceInUSD: string;
    trips: FormattedTrip[];
}) {
    let hasRouted = false;

    const formattedTrips = trips?.map(trip => {
        if (trip?.isRouted) {
            hasRouted = true;
        }

        const {
            arriveName,
            carrierCode,
            departName,
            carrierFees,
            taxes,
            tripId,
        } = trip;

        return {
            arrive_address: arriveName,
            carrier_code: carrierCode,
            carrier_fee: carrierFees,
            depart_address: departName,
            taxes,
            trip_id: tripId,
        };
    });

    amplitude.track('trip_summary_interacted', {
        full_price_usd: totalPriceInUSD,
        has_routed: hasRouted,
        interaction_type: 'price_breakdown_clicked',
        is_one_way: !returnTripId,
        trips: formattedTrips,
    });
}

export default { priceBreakdownButtonClicked };
